/**
 * Unified environment configuration that works in both Node and Browser contexts
 * Jest will map this to a mock file during tests
 */

// Detect if we're in a browser environment
const isBrowser = typeof window !== "undefined";

// Get environment variables safely
const getEnvVar = (key: string, fallback: string): string => {
  if (isBrowser) {
    return import.meta.env[key] || fallback;
  }
  // In Node, use process.env
  return process.env[key] || fallback;
};

const getEnvBool = (key: string, fallback: boolean): boolean => {
  if (isBrowser) {
    return import.meta.env[key] === "true" || fallback;
  }
  return process.env[key] === "true" || fallback;
};

export const getBaseApiUrl = (): string =>
  getEnvVar("VITE_BASE_API_URL", "http://localhost:3000");

export const getEnvironmentMode = (): string =>
  getEnvVar("MODE", "development");

export const isDevelopment = (): boolean => getEnvBool("DEV", false);

export const isProduction = (): boolean => getEnvBool("PROD", false);
